import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { map } from 'lodash-es';

import { CoverageTypeEnum } from '../OfferBlock.enum';

const Coverage = ({ name, type, value, showSubBorder }) => (
  <div
    className={cn(
      'flex-row font-color-sub-text flex-grid-center-vertical',
      type,
      showSubBorder ? 'style-row-sub-border-bottom' : ''
    )}
  >
    <div className="flex-grid-first-sub text-capitalize">
      <span>{name}</span>
    </div>
    <div className="flex-grid">
      <span>{value}</span>
    </div>
  </div>
);

Coverage.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(map(CoverageTypeEnum, item => item)),
  value: PropTypes.string.isRequired,
  showSubBorder: PropTypes.bool.isRequired,
};

Coverage.defaultProps = {
  type: undefined,
};

export default Coverage;
